import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import { Router } from '@angular/router';
import { SharedservicesService } from '../../../../services/sharedservices.service';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { forEach } from '@angular/router/src/utils/collection';
import { async } from '@angular/core/testing';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {
  custemail: any;
  usertype: any;
  apiRoot: string = this.ref.GetPostURL();
  result: any;
  customeremail: any;
  
  customer: any;

  public displayedColumns: Array<any> = [];
  public dataSource: MatTableDataSource<any> = new MatTableDataSource();
  
  public stickyColumns: string[] = ['topics', 'country'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private router: Router, private ref: SharedservicesService, private http: HttpClient) { 
  }
  public fieldNames: Array<any> = [];
  // public fieldNames = ['status', 'datecreated', 'dateupdated', 'heading'];

  public data = [];

  ngOnInit() {
    this.ref.telecastcomplaint.subscribe(user=> this.custemail = user);
    var userLoggedin = JSON.parse(localStorage.getItem('customerInfo'));
    if(!userLoggedin) {
       this.router.navigate(['/']);
    }
    // console.log(JSON.stringify(this.complaintdata));
    // if(this.complaintdata) {
    //   console.log(this.complaintdata);
    // }
    this.displayedColumns = [];
    
    this.fetchDatabase();
  }
  detailedView(element) {
    var headingdata = element.Heading;
    var compantstatus = element.Status;
    var customeremailid = element.Customeremail;
    var userdata = JSON.parse(localStorage.getItem('customerInfo'));
    
    var custstatus = {};
    if(userdata) {
      if(userdata.usertype=='usercustomer') {
        customeremailid = userdata.email;
      } else if(userdata.usertype=='useragent') {
        custstatus = {
          "Id": element.Id,
          "customer": element.Customeremail,
          "heading": element.Heading
        }
      } 
    } else {
      console.log('user not logged in!');
    }
    this.ref.CustomercomplaintStatus(custstatus); 
    this.router.navigate(['/app/dashboard/details'], { queryParams: { custemail:customeremailid, heading:headingdata, status: compantstatus} });
  }
  editView(element) {
    var  custstatus = {
      "Id": element.Id,
      "customer": element.Customeremail,
      "heading": element.Heading
    }
    this.ref.CustomercomplaintStatus(custstatus); 
  }

  isSticky(column: string) {
    return this.stickyColumns.find(val => val === column) !== undefined
      ? true
      : false;
  }

  fetchDatabase() {
    this.fieldNames = [];
    var userdata = JSON.parse(localStorage.getItem('customerInfo'));
    if (userdata) {
      this.custemail = userdata.email;
      this.usertype = userdata.usertype;
      if (this.usertype === 'useragent') {
        this.fieldNames = ['Id', 'Customeremail', 'Status', 'Datecreated', 'Dateupdated', 'Heading'];
        this.displayedColumns.push('action');
        this.displayedColumns.push('edit');
        this.displayedColumns = this.displayedColumns.concat(this.fieldNames);
        // tslint:disable-next-line: no-shadowed-variable
        const usercomplaints = {
          'email': this.custemail
        };
        this.ref.getAllTheCustomerComplaints(usercomplaints).subscribe(async(res) => {
          if (res) {
            const resultD = JSON.parse(JSON.stringify(res));
            this.result = resultD;
            this.result.forEach(data => {
               this.data.push({
                Id: data._id,
                Customeremail:data.email,
                Status: data.status,
                Datecreated: data.datecreated,
                Dateupdated: data.dateupdated,
                Heading: data.heading
               });
            });
            this.dataSource.data = await this.data;
            this.dataSource.paginator = await this.paginator;
          }
        },
          error => {
            console.log("Error", error);
            var value = (<HTMLInputElement>document.getElementById("Nodatafound"));
            value.style.display = 'block';
          }
        );
        // this.http.post(geturlallcustomerdata, usercomplaints).subscribe( async data => {
        //     this.result = await data;
        //     this.result.forEach(data => {
        //        this.data.push({
        //         Id: data._id,
        //         Customeremail:data.email,
        //         Status: data.status,
        //         Datecreated: data.datecreated,
        //         Dateupdated: data.dateupdated,
        //         Heading: data.heading
        //        });
        //     });
        //     this.dataSource.data = await this.data;
        //     this.dataSource.paginator = await this.paginator;
        //     // var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
        //     // value.style.display = 'none';
        //     // this.router.navigate(['/app/dashboard'], { queryParams: {} });
        //   },
        //   error => {
        //     console.log("Error", error);
        //     var value = (<HTMLInputElement>document.getElementById("Nodatafound"));
        //     value.style.display = 'block';
        //   }
        // );
      } else if (this.usertype === 'usercustomer') {
        this.fieldNames = ['Id', 'Status', 'Datecreated', 'Dateupdated', 'Heading'];
        this.displayedColumns.push('action');
        this.displayedColumns = this.displayedColumns.concat(this.fieldNames);
        var usercomplaints = {
          'email': this.custemail
        };

        this.ref.getOnlyCustomerComplaints(usercomplaints).subscribe(async(res) => {
          if (res) {
            const resultD = JSON.parse(JSON.stringify(res));
            this.result = resultD;
            this.result.forEach(data => {
              this.data.push({
               Id: data._id, 
               Status: data.status,
               Datecreated: data.datecreated,
               Dateupdated: data.dateupdated,
               Heading: data.heading
              });
           });
           this.dataSource.data = await this.data;
           this.dataSource.paginator = await this.paginator;
          }
        },
          error => {
            console.log("Error", error);
            var value = (<HTMLInputElement>document.getElementById("Nodatafound"));
            value.style.display = 'block';
          }
        );
        // this.http.post(geturlcustomer, usercomplaints).subscribe( async data => {
        //     this.result = await data;
        //     // console.log(this.result)
        //     this.result.forEach(data => {
        //        this.data.push({
        //         Id: data._id, 
        //         Status: data.status,
        //         Datecreated: data.datecreated,
        //         Dateupdated: data.dateupdated,
        //         Heading: data.heading
        //        });
        //     });
        //     this.dataSource.data = await this.data;
        //     this.dataSource.paginator = await this.paginator;      
        //     // var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
        //     // value.style.display = 'none';
        //     // this.router.navigate(['/app/dashboard'], { queryParams: {} });
        //   },
        //   error => {
        //     console.log("Error", error);
        //     var value = (<HTMLInputElement>document.getElementById("Nodatafound"));
        //     value.style.display = 'block';
        //   }
        // );
      }
    }
  }
}

